import requests from "./httpServices.js";

class UserService {
  async getAdminSettings() {
    try {
      const response = await requests.get(`/users/settings`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }
  async getUserProfile() {
    try {
      const response = await requests.get(`/auth/profile`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateUserProfile(data) {
    try {
      const response = await requests.put(`/auth/update-profile`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async uploadProfilePicture(formData) {
    try {
      const response = await requests.post(
        `/users/update-logo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async changePassword(data) {
    try {
      const response = await requests.post(`/auth/change-password`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateUserPreferences(data) {
    try {
      const response = await requests.post(`/auth/update-user-settings`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getUserPreferences() {
    try {
      const response = await requests.get(`/auth/user-preferences`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async preRegister(data) {
    try {
      const response = await requests.post(`/auth/pre-register`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async postRegister(data) {
    try {
      const response = await requests.post(`/auth/post-register`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async checkUserExists(email) {
    try {
      const response = await requests.get(`/users/check-email/${encodeURIComponent(email)}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response?.data) {
      const { message, errors } = error.response.data;

      if (errors && typeof errors === "object") {
        // Handle validation errors
        const errorMessages = Object.values(errors).flat();
        return new Error(errorMessages.join(", "));
      }

      if (message) {
        return new Error(message);
      }
    }

    if (error.message) {
      return new Error(error.message);
    }

    return new Error("An unexpected error occurred");
  }
}

// Export singleton instance
const userService = new UserService();
export default userService;
